import api from './api';

export interface AIEnhancementRequest {
  table: string;
  fieldName: string;
  currentValue?: string;
  mode: 'generate' | 'improve';
  recordId?: number;
  context?: Record<string, any>;
}

export interface AIEnhancementResult {
  enhanced_content: string;
  context_used: string[];
  search_results_used?: string[];
  original_content?: string;
  suggestions?: string[];
  mode?: 'replace' | 'append';
}

export interface AIEditableField {
  field_name: string;
  label: string;
  ai_enhancement_type: string;
  ai_context_prompt: string;
}

export interface BulkEnhancementRequest {
  table: string;
  recordId: number;
  mode: 'generate' | 'improve';
}

export const aiEnhancementService = {
  /**
   * Enhance a specific field using AI
   */
  async enhanceField(request: AIEnhancementRequest): Promise<AIEnhancementResult> {
    try {
      const response = await api.post('/ai/enhance/field', request);
      return response.data;
    } catch (error) {
      console.error('Error enhancing field:', error);
      throw new Error('Failed to enhance field');
    }
  },

  /**
   * Bulk enhance all AI-editable fields for a record
   */
  async bulkEnhanceRecord(request: BulkEnhancementRequest): Promise<Record<string, AIEnhancementResult>> {
    try {
      const response = await api.post('/ai/enhance/bulk', request);
      return response.data;
    } catch (error) {
      console.error('Error bulk enhancing record:', error);
      throw new Error('Failed to enhance record');
    }
  },

  /**
   * Get AI editable fields for a table
   */
  async getAIEditableFields(table: string): Promise<AIEditableField[]> {
    try {
      const response = await api.get(`/ai/fields/${table}`);
      return response.data;
    } catch (error) {
      console.error('Error getting AI editable fields:', error);
      throw new Error('Failed to get AI editable fields');
    }
  },

  /**
   * Test AI functionality
   */
  async testAI(messages: Array<{ role: 'user' | 'assistant' | 'system'; content: string; }>): Promise<{ message: string; error?: string }> {
    try {
      const response = await api.post('/ai/test', { messages });
      return response.data;
    } catch (error) {
      console.error('Error testing AI:', error);
      throw new Error('Failed to test AI');
    }
  }
}; 